var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59418 0.26832C1.42056 0.0947008 1.19959 0 0.939161 0C0.418304 0 4.1008e-05 0.410372 4.1008e-05 0.931229C4.1008e-05 1.19166 0.110526 1.42841 0.292036 1.60992L5.81628 7.00789L0.292036 12.3901C0.110526 12.5716 4.1008e-05 12.8162 4.1008e-05 13.0688C4.1008e-05 13.5896 0.418304 14 0.939161 14C1.19959 14 1.42056 13.9053 1.59418 13.7317L7.73398 7.73393C7.95494 7.52875 8.05754 7.27621 8.06543 7C8.06543 6.72379 7.95494 6.48703 7.73398 6.27396L1.59418 0.26832Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.cbea25c5c0e20633a4a136416ca13d4f.svg";
export { ForwardRef as ReactComponent };